import { configureStore } from '@reduxjs/toolkit'
import adminReducer from 'slices/admins'
import authReducer from 'slices/auth'
import clientReducer from 'slices/client'
import singleClientReducer from 'slices/singleClient'
import walletTransactionReducer from 'slices/clientWalletTransactions'
import templateReducer from 'slices/template'
import invloiceReducer from 'slices/invoice'
import paymentReducer from 'slices/payment'
import usersReducer from 'slices/users'
import clientWhatsAppDetailsReducer from 'slices/clientWhatsAppDetails'
import broadcastsReducer from 'slices/broadcasts'
import broadcastReducer from 'slices/broadcast'
import broadcastContactReducer from 'slices/broadcastContact'
import broadcastEnquiriesReducer from 'slices/broadcastEnquiries'
import subscriptionReducer from 'slices/subscriptions'

export const store = configureStore({
	reducer: {
		auth: authReducer,
		client: clientReducer,
		admin: adminReducer,
		singleClient: singleClientReducer,
		walletTransaction: walletTransactionReducer,
		template: templateReducer,
		invoice: invloiceReducer,
		payment: paymentReducer,
		users: usersReducer,
		clientWhatsAppDetails: clientWhatsAppDetailsReducer,
		broadcasts: broadcastsReducer,
		broadcast: broadcastReducer,
		broadcastContact: broadcastContactReducer,
		broadcastEnquiries: broadcastEnquiriesReducer,
		subscription: subscriptionReducer,
	},
})

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch
